import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import type {} from '@mui/x-date-pickers/AdapterLuxon';

function Providers({ children }: { children: ReactNode }) {
	const { i18n } = useTranslation();
	const localeMap: any = {
		en: 'en-GB',
		tr: 'tr-TR',
		uk: 'uk',
	};

	const currentLocale = localeMap[i18n.language] || i18n.language;

	return (
		<LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={currentLocale}>
			{children}
		</LocalizationProvider>
	);
}

export default Providers;
